<script lang="ts">
    import {
        VpCheckIcon,
        VpCloseIcon,
    } from '@decathlon-experience/icons/svelte';
    import { createEventDispatcher, onMount } from 'svelte';
    import { writable } from 'svelte/store';

    import { trans } from '$assets/translator';
    import Button from '$saga/components/Button.svelte';
    import Modal from '$saga/components/Modal.svelte';

    export let src: string;
    export let initialFocalPoint: { x: number; y: number } = { x: 50, y: 50 };

    const isOpen = writable(true);

    const dispatch = createEventDispatcher<{
        confirm: { focalPoint: { x: number; y: number } };
        cancel: void;
    }>();

    let focalPointEdited = initialFocalPoint;

    const handleClick = (event: MouseEvent) => {
        const el = event.currentTarget as HTMLElement;
        focalPointEdited = {
            x: Math.round((event.offsetX / el.offsetWidth) * 100),
            y: Math.round((event.offsetY / el.offsetHeight) * 100),
        };
    };

    const confirm = () => {
        dispatch('confirm', { focalPoint: focalPointEdited });
    };

    const cancel = () => {
        dispatch('cancel');
    };

    onMount(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                cancel();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    });
</script>

<Modal {isOpen} fullScreen={true} onClose={cancel}>
    <svelte:fragment slot="header">
        <div class="flex items-center justify-between">
            <h2 class="text-lg font-semibold">
                {trans('form.multi_image_upload.focal_point.title')}
            </h2>
            <button
                type="button"
                on:click={cancel}
                class="focus:ring-border-focus rounded p-xs focus:outline-none focus:ring-2"
                aria-label="Fermer"
            >
                <VpCloseIcon class="size-xl text-content-neutral" />
            </button>
        </div>
    </svelte:fragment>

    <div class="flex h-[calc(100vh-89px)] flex-col gap-m p-m">
        <p class="text-sm text-content-quiet">
            {trans('form.multi_image_upload.focal_point.hint')}
        </p>
        <!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
        <div
            class="relative flex-1 cursor-crosshair overflow-hidden"
            on:click={handleClick}
        >
            <img {src} alt="" class="h-full w-full object-contain" />
            <div
                class="bg-content-brand shadow pointer-events-none absolute size-l -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white opacity-80"
                style="left: {focalPointEdited.x}%; top: {focalPointEdited.y}%;"
            ></div>
        </div>
        <div class="flex w-full items-center justify-end gap-m">
            <Button intent="secondary" type="button" on:click={cancel}>
                {trans('action.back')}
            </Button>
            <Button intent="primary" type="button" on:click={confirm}>
                <VpCheckIcon class="size-m" />
                {trans('action.confirm')}
            </Button>
        </div>
    </div>
</Modal>
